<template>
	<div class="video-preview-poster h-100">
		<v-img
			:src="effectiveThumbnail"
			:lazy-src="effectiveThumbnail"
			height="100%"
			cover
			:class="{ 'video-preview-poster--placeholder': isPlaceholder }"
			@error="hasImageError = true">
			<img class="video-preview-poster__copy" :src="fallbackImageUrl" alt="Video preview poster" @contextmenu.stop />
		</v-img>
		<v-icon
			class="video-preview-poster__play"
			:class="{
				'video-preview-poster__play--compact': display.smAndDown.value
			}"
			data-test-id="video-play"
			aria-hidden="true"
			>icon-play-solid</v-icon
		>
		<slot />
	</div>
</template>

<script setup lang="ts">
	import { computed, ref, watch } from "vue";
	import { useDisplay } from "vuetify";
	import { VIcon, VImg } from "vuetify/lib/components/index.mjs";
	import fallbackImageUrl from "../assets/lsc-poster.svg";

	const props = defineProps<{ thumbnail?: string | null }>();
	const display = useDisplay();
	const hasImageError = ref(false);
	const isPlaceholder = computed(() => hasImageError.value || !props.thumbnail);
	const effectiveThumbnail = computed(() => (isPlaceholder.value ? fallbackImageUrl : props.thumbnail!));
	watch(
		() => props.thumbnail,
		() => {
			hasImageError.value = false;
		}
	);
</script>

<style scoped>
	.video-preview-poster {
		position: relative;
		overflow: hidden;
		width: 100%;
		background: #000;
	}
	.video-preview-poster--placeholder {
		background: #eee;
	}
	.video-preview-poster__copy {
		position: absolute;
		inset: 0;
		width: 100%;
		height: 100%;
		opacity: 0;
		pointer-events: auto;
		z-index: 1;
		object-fit: cover;
	}
	.video-preview-poster__play {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		width: 2.5rem;
		height: 2.5rem;
		border-radius: 50%;
		background: #0006;
		color: #fff;
		font-size: 2rem;
		z-index: 1;
	}
	.video-preview-poster__play::before,
	.video-preview-poster__play :deep([class^="icon-"]::before) {
		margin: 0;
	}
	.video-preview-poster__play--compact {
		width: 2.25rem;
		height: 2.25rem;
	}
</style>
